import { render, staticRenderFns } from "./ViewTicket.vue?vue&type=template&id=dc6fb0e0&"
import script from "./ViewTicket.vue?vue&type=script&lang=js&"
export * from "./ViewTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports